import { render, staticRenderFns } from "./TemplateShare.vue?vue&type=template&id=6fed7137&scoped=true&"
import script from "./TemplateShare.vue?vue&type=script&lang=js&"
export * from "./TemplateShare.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-share.scss?vue&type=style&index=0&id=6fed7137&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed7137",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fed7137')) {
      api.createRecord('6fed7137', component.options)
    } else {
      api.reload('6fed7137', component.options)
    }
    module.hot.accept("./TemplateShare.vue?vue&type=template&id=6fed7137&scoped=true&", function () {
      api.rerender('6fed7137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateShare.vue"
export default component.exports